export { default } from './Footer'; 